import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

type ChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => void;

interface UrlTogglePanelOwnProps {
  // i18n keys for the legend and the URL field's label.
  legendKey: string;
  urlLabelKey: string;
  // data-redisid values on the two inputs. Not read by any handler any more —
  // both handlers know their own c-key — but kept because they are the hooks
  // the field is identified by elsewhere (and in the DOM, for support).
  toggleRedisId: string;
  urlRedisId: string;
  // Native `title` tooltip on the checkbox; literal English, as before.
  toggleTitle: string;
  enabled: boolean;
  onToggleEnabled: ChangeHandler;
  url: string;
  onChangeUrl: ChangeHandler;
}

// The legal-notice and lottery-rules blocks were byte-identical apart from their
// labels, ids and c-keys: an enable checkbox gating a single URL input. They
// share this component now, so the two cannot drift apart.
//
// Note the gate is `!enabled`, computed by the caller. The container used to
// write `{value} == false ? "hidden" : ""` against the raw store value, which is
// wrong for an unset key — `undefined == false` is false in JS — so each caller
// applies its own default before passing `enabled` in.
const UrlTogglePanel = ({
  legendKey, urlLabelKey, toggleRedisId, urlRedisId, toggleTitle,
  enabled, onToggleEnabled, url, onChangeUrl, t,
}: UrlTogglePanelOwnProps & WithTranslation) => (
  <fieldset>
    <legend>{t(legendKey)}</legend>
    <label>{t('target.editor.label.enable')}</label>
    <input type="checkbox" data-redisid={toggleRedisId}
      title={toggleTitle}
      checked={enabled}
      onChange={onToggleEnabled}
    />
    <div className={!enabled ? "hidden" : ""}>
      <label>{t(urlLabelKey)}</label>
      <input type="text" data-redisid={urlRedisId}
        value={url}
        onChange={onChangeUrl}
      />
    </div>
  </fieldset>
);

export default withTranslation('common')(UrlTogglePanel);
